/**
 *
 */
export enum CO2Unit {
    Kg = "kg",
    Lb = "lb",
}